import { Loader } from "@ui-kit/Loader";

export const FileLoader = () => {
	return (
		<div data-loader="true">
			<Loader size="3xl" />
		</div>
	);
};
